import { useEffect, useRef, useState } from "react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../CustomComponents/FieldInput";
import ReactSelect from "react-select";
import axiosInstance from "../../../redux/api";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import FileAttachment from "./FileAttachment";
import {
  getCategary,
  getIndustry,
  getLanguage,
  getWithParentCategary,
} from "../../../redux/categary/action";
import { GetCountry } from "../../../redux/master/action";
import { getUserProfile } from "../../../redux/hire/action";
import CustomReactQuill from "../../Common/CustomeLabel/ReactQuill/CustomReactQuill";
import ImportantNoteOTS from "../../Common/ImportantNote/ImportantNoteOTS";
import ProfilePic from "../../../assests/imgs/Profileplaceholder.svg";
import { descriptionvalidation, filesvalidationforstatusbase, titlevalidation } from "../../Common/commonvalidation";
import ProfileImageWithFallback from "../../../common/ProfileImageWithFallback";
import AsteriskLabel from "../../Common/AsteriskLabel";
import CommissionNote from "../../Common/ImportantNote/CommissionNote";
import CoverImages from "../../Common/CoverImages";
import CompanyFileUpload from "../ExpertCompanyRegistration/DifferentFlow/CompanyFlow/CompanyFileUpload";

const validationSchema = Yup.object().shape({
  hiring_type: Yup.string().required("This is required"),
  title: titlevalidation,
  category_id: Yup.string().required("This is required"),
  // sub_category_id: Yup.string().required('This is required'),
  price: Yup.number()
    .required("This is required")
    .min(1, "price can not be zero"),
  description: descriptionvalidation,
  work_location: Yup.string().required("This is required"),
  working_country: Yup.string().required("This is required"),
  city: Yup.string()
    .required("This is required")
    .test(
      "not-only-spaces",
      "Please enter a valid value",
      (value) => value.trim() !== ""
    ),
  language_id: Yup.string().required("This is required"),
  files: filesvalidationforstatusbase,
});

export default function YouExpertHiring() {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");

  const [formData, setFormData] = useState("");
  const navigate = useNavigate();
  const formikRef = useRef(null);
  const path = "Assets/scss/postproject.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const initialValues = {
    hiring_type: formData?.hiring_type || 1,
    title: formData?.title || "",
    category_id: formData?.category_id || "",
    sub_category_id: formData?.sub_category_id || "",
    price: formData?.price || "",
    last_date: formData?.last_date || "",
    description: formData?.description || "",
    work_location: formData?.work_location || 1,
    working_country: formData?.working_country || "",
    city: formData?.city || "",
    language_id: formData?.language_id || "",
    files: formData?.files || [],
  };

  const formdatatomap = [
    { title: (<>Hiring Type <AsteriskLabel /></>), name: "hiring_type", placeholder: "Hiring Type" },
    { title: (<>Job Title <AsteriskLabel /></>), name: "title", placeholder: "Job Title" },
    {
      title: (<>Industry <AsteriskLabel /></>),
      name: "industry_id",
      placeholder: "Select an Industry",
    },
    {
      title: (<>Select Category <AsteriskLabel /></>),
      name: "category_id",
      placeholder: "Select An Option",
    },
    // { title: "Select sub category", name: "sub_category_id", placeholder: 'Select An Option' },
    {
      title: (<>Work Location <AsteriskLabel /></>),
      name: "work_location",
      placeholder: "work_location2",
    },
    {
      title: (<>Preferred working country <AsteriskLabel /></>),
      name: "working_country",
      placeholder: "Select An Option",
    },
    { title: (<>City <AsteriskLabel /></>), name: "city", placeholder: "City" },
    {
      title: (<>Job Description <AsteriskLabel /></>),
      name: "description",
      placeholder: "Enter detailed job description",
    },
    {
      title: (<>Price <AsteriskLabel /></>),
      name: "price",
      placeholder: formData.hiring_type == 1 ? "Enter price " : "Enter price ",
    },
    {
      title: (<>Preferred Language of Work Submission <AsteriskLabel /></>),
      name: "language_id",
      placeholder: "Select Language",
    },
    { title: "Attach documents for reference", name: "files", placeholder: "Select Image" },
  ];
  const { id } = useParams();

  const [selectCountry, setSelectCountry] = useState(
    formData?.working_country_index
  );
  const [parentid, setParentid] = useState("");
  const [category, setCategory] = useState(formData?.category_id);
  const [subcategory, setSubcategory] = useState(formData?.sub_category_id);
  const [selectCatgory, setselectCatgory] = useState(formData.category_index);
  const [selectSubcategory, setSelectSubcategory] = useState(
    formData.subcategory_index
  );
  const [work_sample, setWork_sample] = useState({ files: formData?.files });
  const [industrySelected, setIndustrySelected] = useState("");

  const countrylist = useSelector(({ master: { countrylist } }) => countrylist);
  const categarylist = useSelector(
    ({ categary: { categarylist } }) => categarylist
  );
  const TheIndustryList = useSelector(
    ({ categary: { industrylist } }) => industrylist
  );

  useEffect(() => {
    setCategory(categarylist);
  }, [categarylist]);

  useEffect(() => {
    axiosInstance
      .get(`category?type=3&parent_id=${parentid}`)
      .then((response) => {
        setSubcategory(response?.data?.response);
      });
  }, [parentid]);

  const handleSubmit = async (values) => {
    const filteredFiles = Array.isArray(values?.files) ? values?.files?.filter(
      (item) => item?.status != 3
    ) : [];

    const data = {
      ...values,
      type: "4",
      expert_id: id,
      files: filteredFiles
    };

    navigate(`/${lan}/hireexpertjobdetails/${id}`, {
      state: { userinfo: data },
    });
    // dispatch(HireExpert(data))
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLanguage());
    dispatch(GetCountry());
    dispatch(getIndustry());
  }, [dispatch]);

  useEffect(() => {
    industrySelected && dispatch(getWithParentCategary(industrySelected));
  }, [industrySelected]);

  const getuserprofile = useSelector(
    ({ hire: { getuserprofile } }) => getuserprofile
  );

  useEffect(() => {
    dispatch(getUserProfile(id));
  }, [id]);

  const handleNextClick = () => {
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [allLanguage, setAllLanguage] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const languagelist = useSelector(
    ({ categary: { languagelist } }) => languagelist
  );

  useEffect(() => {
    setAllLanguage(languagelist);
  }, [languagelist]);

  const handleWorkingcountryChange = (selectedOption, formik) => {
    setSelectCountry(selectedOption);
    formik.setValues({
      ...formik.values,
      working_country_index: selectedOption,
      working_country: selectedOption.value,
    });
  };

  return (
    <>
      <div className="expert-flow col-lg-10 mx-auto youexpert ">
        <div className="col-lg-10 mx-auto">
          <div className="row about-row">
            <div className="col-md-5 about-left">
              {/* <h6>
                01/03 <span>Hire expert</span>
              </h6> */}
              <h2>You are hiring</h2>
              <div className="expert-left">
                <ProfileImageWithFallback url={getuserprofile?.profile_image} className="" />
                <div>
                  <h2>
                    {getuserprofile?.first_name} {getuserprofile?.last_name}
                  </h2>
                  <h6>
                    {getuserprofile?.expert
                      ? getuserprofile?.expert?.designation
                      : ""}
                    {getuserprofile?.company
                      ? getuserprofile?.company?.cr_number
                      : ""}
                    <span className="w-100">
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/map-icon.svg`}
                        alt=""
                      />
                      {getuserprofile?.country_title}
                    </span>
                  </h6>
                  {/* <div className="star">
                    <p>
                      <i className="fa-solid fa-star"></i> 4.5 (3 jobs)
                    </p>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="col-lg-6   about-right">
              <CommissionNote type={'hiring'} item={"hired expert"} />
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
                innerRef={formikRef}
              >
                {(formik) => (
                  <Form>
                    { }
                    {formdatatomap.map((prop, key) => {
                      if (prop.name == "hiring_type") {
                        return (
                          <div key={key} className="form-group">
                            <h6>{prop.title} </h6>
                            <div className="checkbox-label">
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  name={prop.name}
                                  checked={formik.values[prop.name] == 1}
                                  value="1"
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      [prop.name],
                                      e.target.value
                                    );
                                  }}
                                />
                                <span className="checkmark">Hourly</span>
                                <label className="checkbox-container">
                                  <Field
                                    type="radio"
                                    name={prop.name}
                                    checked={formik.values[prop.name] == 3}
                                    value="3"
                                    onChange={(e) => {
                                      formik.setFieldValue(
                                        [prop.name],
                                        e.target.value
                                      );
                                    }}
                                  />
                                  <span className="checkmark">Weekly</span>
                                </label>
                              </label>
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  name={prop.name}
                                  checked={formik.values[prop.name] == 4}
                                  value="4"
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      [prop.name],
                                      e.target.value
                                    );
                                  }}
                                />
                                <span className="checkmark">Monthly</span>
                              </label>
                            </div>
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      if (prop.name === "industry_id") {
                        return (
                          <div className="row" key={key}>
                            <div className="form-group col-md-6">
                              <label>{prop.title}</label>
                              <ReactSelect
                                options={
                                  TheIndustryList &&
                                  Array.isArray(TheIndustryList) &&
                                  TheIndustryList?.map((lang) => ({
                                    value: lang.id,
                                    label: lang.title,
                                  }))
                                }
                                placeholder={prop.placeholder}
                                value={
                                  Array.isArray(TheIndustryList)
                                    ? TheIndustryList?.map((lang) => ({
                                      value: lang.id,
                                      label: lang.title,
                                    })).find(
                                      (opt) =>
                                        opt.value ===
                                        formik.values.industry_id
                                    )
                                    : null
                                }
                                onChange={(selectedOption) => {
                                  setselectCatgory("");
                                  setSelectSubcategory("");
                                  setIndustrySelected(selectedOption?.value);
                                  formik.setFieldValue(
                                    "industry_id",
                                    selectedOption?.value || ""
                                  );
                                  formik.setFieldValue(
                                    "industry_index",
                                    selectedOption
                                  );
                                  formik.setFieldValue("category_id", "");
                                  formik.setFieldValue("subcategory_index", "");
                                  formik.setFieldValue("sub_category_id", "");
                                }}
                              />
                              <ErrorMessage
                                name={prop.name}
                                component="div"
                                className="error"
                              />
                            </div>
                          </div>
                        );
                      }
                      if (prop.name == "category_id") {
                        return (
                          <>
                            {Array.isArray(category) && category?.length > 0 ?
                              <div className="row" key={key}>
                                <div className="form-group col-md-6">
                                  <label>{prop.title}</label>
                                  <ReactSelect
                                    options={
                                      Array.isArray(category) &&
                                      category.map((lang) => ({
                                        value: lang.id,
                                        label: lang.title,
                                      }))
                                    }
                                    placeholder={prop.placeholder}
                                    value={selectCatgory}
                                    onChange={(options) => {
                                      setselectCatgory(options);
                                      setParentid(options.value);
                                      setSelectSubcategory("");
                                      formik.setFieldValue(
                                        "category_index",
                                        options
                                      );
                                      formik.setFieldValue(
                                        prop.name,
                                        options.value
                                      );
                                      formik.setFieldValue("subcategory_index", "");
                                      formik.setFieldValue("sub_category_id", "");
                                    }}
                                  />
                                  {/* <ErrorMessage
                                    name={prop.name}
                                    component="div"
                                    className="error"
                                  /> */}
                                </div>
                                <>
                                  {
                                    (Array.isArray(subcategory) && subcategory?.length > 0) ?
                                      <>
                                        {formik?.values?.category_id && (
                                          <div className="form-group col-md-6">
                                            <label>Select sub category</label>
                                            <ReactSelect
                                              options={
                                                Array.isArray(subcategory) &&
                                                subcategory.map((lang) => ({
                                                  value: lang.id,
                                                  label: lang.title,
                                                }))
                                              }
                                              placeholder="Select An Option"
                                              noOptionsMessage={() => "No option"}
                                              value={selectSubcategory}
                                              onChange={(options) => {
                                                setSelectSubcategory(options);
                                                formik.setFieldValue(
                                                  "sub_category_id",
                                                  options.value
                                                );
                                                formik.setFieldValue(
                                                  "subcategory_index",
                                                  options
                                                );
                                              }}
                                            />
                                            <ErrorMessage
                                              name="sub_category_id"
                                              component="div"
                                              className="error"
                                            />
                                          </div>
                                        )}
                                      </>
                                      : <></>
                                  }
                                </>
                              </div> :
                              <></>}
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </>
                        );
                      }
                      if (prop.name == "sub_category_id") {
                        return null;
                      }
                      if (prop.name == "work_location") {
                        return (
                          <div className="form-group" key={key}>
                            <h6>{prop.title}</h6>
                            <div className="checkbox-label">
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  name={prop.name}
                                  checked={formik.values[prop.name] == 1}
                                  value="1"
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      [prop.name],
                                      e.target.value
                                    );
                                  }}
                                />
                                <span className="checkmark">Virtual</span>
                              </label>
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  name={prop.name}
                                  checked={formik.values[prop.name] == 2}
                                  value="2"
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      [prop.name],
                                      e.target.value
                                    );
                                  }}
                                />
                                <span className="checkmark">Physical</span>
                              </label>
                            </div>
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      if (prop.name == "working_country") {
                        return (
                          <div className="form-group" key={key}>
                            <label>{prop.title}</label>
                            <ReactSelect
                              options={
                                Array.isArray(countrylist) &&
                                countrylist.map((lang) => ({
                                  value: lang.id,
                                  label: lang.title,
                                }))
                              }
                              placeholder={prop.placeholder}
                              value={selectCountry}
                              onChange={(options) =>
                                handleWorkingcountryChange(options, formik)
                              }
                            />
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      if (prop.name == "language_id") {
                        return (
                          <div className="form-group" key={key}>
                            <label>{prop.title}</label>
                            <ReactSelect
                              options={
                                Array.isArray(allLanguage) &&
                                allLanguage.map((lang) => ({
                                  value: lang.id,
                                  label: lang.title,
                                }))
                              }
                              placeholder={prop.placeholder}
                              value={selectedLanguage}
                              onChange={(options) => {
                                setSelectedLanguage(options);
                                formik.setFieldValue("language_index", options);
                                formik.setFieldValue(prop.name, options.value);
                              }}
                            />
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      // if (prop.name == "description") {
                      //   return (
                      //     <div key={key}>
                      //       <Field
                      //         name={prop.name}
                      //         as={FieldArea}
                      //         title={prop.title}
                      //         value={formik.values[prop.name]}
                      //         placeholder={prop.placeholder}
                      //         handleChange={handleChange}
                      //       />
                      //     </div>
                      //   );
                      // }
                      if (prop.name == "description") {
                        return (
                          <>
                            <CustomReactQuill
                              value={formik.values.description}
                              formik={formik}
                              name={prop.name}
                              title={prop.title}
                            />
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                              style={{ color: "red" }}
                            />
                          </>
                        );
                      }
                      if (prop.name == "files") {
                        return (
                          <>
                            <div key={key}>
                              {/* <h6>{prop.title}</h6> */}
                              <h6>Attach documents for reference <AsteriskLabel /></h6>
                              <CompanyFileUpload formik={formik} name={`files`} />
                              <ErrorMessage name={prop.name} component="div" className="error" />
                            </div>
                          </>
                        );
                      }
                      if (prop.name == "price") {
                        return (
                          <div key={key}>
                            <FieldInput
                              name={prop.name}
                              value={formik.values[prop.name]}
                              placeholder={prop.placeholder}
                              title={prop.title}
                              handleChange={handleChange}
                              type="number"
                              min="1"
                            />
                          </div>
                        );
                      }
                      return (
                        <div key={key}>
                          <FieldInput
                            name={prop.name}
                            value={formik.values[prop.name]}
                            placeholder={prop.placeholder}
                            title={prop.title}
                            handleChange={handleChange}
                            type="text"
                          />
                        </div>
                      );
                    })}
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <div className="button-container col-lg-8 col-md-11 mx-auto d-flex justify-content-end">
        {/* <button hiring_type='button' className='next-button' onClick={() => navigate(-1)}>Cancel</button> */}
        <button
          hiring_type="submit"
          className="next-button"
          onClick={handleNextClick}
        >
          Next
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
            alt=""
          />
        </button>
      </div>
    </>
  );
}
